import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalTitle,
  ModalClose,
  ModalFooter,
  Icon,
} from '@repo/ui/components'
import { Button, Input } from '@repo/ui/components'
import { useTranslate, MessagesKeys } from '@repo/shared/hooks'
import { useState } from 'react'
import { ICity } from './city.drawer'

interface INeighborhood {
  value: string
  label?: string
  labelKey?: string
}

interface NeighborhoodDrawerProps {
  items: INeighborhood[]
  cityItems: ICity[]
  open: boolean
  city: string
  value?: string
  onChange: (value: string) => void
  onClose: () => void
}

export const NeighborhoodDrawer = ({
  items,
  cityItems,
  open,
  city,
  value,
  onChange,
  onClose,
}: NeighborhoodDrawerProps) => {
  const { t } = useTranslate()
  const [search, setSearch] = useState('')
  const neighborhoods: INeighborhood[] = items || []

  const filtered = neighborhoods.filter(
    (n) =>
      n.value === 'all' ||
      (n.label && n.label.includes(search)) ||
      (n.labelKey && t(n.labelKey as MessagesKeys).includes(search)),
  )

  const cityLabel = cityItems.find((c) => c.value === city)?.label || ''

  return (
    <Modal open={open} onOpenChange={onClose}>
      <ModalContent>
        <ModalHeader>
          <ModalTitle className='text-center'>
            {t('filters_neighborhood' as MessagesKeys)}
          </ModalTitle>
          <Input
            placeholder={t('filters_neighborhood_search' as MessagesKeys, {
              city: cityLabel || '-',
            })}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            icon={<Icon name='SearchLine' />}
          />
          <ModalClose />
        </ModalHeader>
        <div className='flex max-h-[228px] overflow-y-auto flex-col gap-md py-md'>
          {filtered.map((n) => (
            <Button
              key={n.value}
              variant={value === n.value ? 'ghost' : 'transparent'}
              className='justify-start [&_svg]:fill-unset active:[&_svg]:fill-unset'
              width='full'
              onClick={() => onChange(n.value)}
            >
              <span className='flex items-center gap-xs'>
                {value === n.value ? (
                  <Icon
                    name='SelectionIndicator'
                    color='fill-unset'
                    size='sm'
                  />
                ) : (
                  <span className='w-5 h-5' />
                )}
                {n.labelKey
                  ? t(n.labelKey as MessagesKeys, { city: cityLabel || '-' })
                  : n.label}
              </span>
            </Button>
          ))}
        </div>
        <ModalFooter>
          <Button onClick={onClose} className='w-full' variant='fill'>
            {t('filters_apply')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
